import getURLParams from 'utils/DOM/getURLParams'

function saveSalesForceId(email) {
  const urlParams = getURLParams()
  const idLead = urlParams['id_lead']
  if (idLead && email) {
    sessionStorage.setItem('pivotSFLeadId-' + email, idLead)
  }
}

export default saveSalesForceId
